import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import { TokenService } from '@ninety/platform/services/services/token.service';
import { environment } from '@ninety/ui/web/environments';

const mazSmartRockRegex = /api\/v4\/Maz\/RockAssistant/i;

export function NinetyAuthServiceInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  if (!shouldAttachAuthorizationToken(req.url)) return next(req);

  const tokenService = inject(TokenService);
  const token = tokenService.getAccessToken();
  if (!token) return next(req);

  const clonedRequest = req.clone({
    headers: req.headers.set('Authorization', `Bearer ${token}`),
  });
  return next(clonedRequest);
}

function shouldAttachAuthorizationToken(url: string): boolean {
  return (
    url.startsWith(environment.authApiOrigin) ||
    url.includes('/api/v1/pa/') ||
    url.includes('/api/v4/integrations') ||
    mazSmartRockRegex.test(url) ||
    url.startsWith(environment.mazOrchestratorApiOrigin) ||
    url.startsWith(environment.meetingAgentApiOrigin)
  );
}
